"use strict";
(self["webpackChunkvipc"] = self["webpackChunkvipc"] || []).push([["/assets/collection-app"],{

/***/ "./node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CartItem.vue?vue&type=script&lang=js":
/*!*****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CartItem.vue?vue&type=script&lang=js ***!
  \*****************************************************************************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: "CartItem",
  props: ['item'],
  data: function data() {
    return {
      removeItem: false
    };
  }
});

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CartItem.vue?vue&type=template&id=6428cdfa":
/*!*********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CartItem.vue?vue&type=template&id=6428cdfa ***!
  \*********************************************************************************************************************************************************************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "render": () => (/* binding */ render)
/* harmony export */ });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.esm-bundler.js");

var _hoisted_1 = {
  "class": "flex flex-col gap-1"
};
var _hoisted_2 = {
  "class": "cart-item-bg rounded-t-xl p-6"
};
var _hoisted_3 = {
  "class": "flex gap-6"
};
var _hoisted_4 = {
  "class": "flex-auto flex flex-col gap-3 leading-5"
};
var _hoisted_5 = {
  "class": "font-bold uppercase"
};

var _hoisted_6 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("br", null, null, -1
/* HOISTED */
);

var _hoisted_7 = {
  "class": "text-sm text-lm-dark dark:text-dm-light uppercase tracking-widest"
};
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = {
  "class": "text-sm text-lm-dark dark:text-dm-light"
};
var _hoisted_10 = {
  "class": "text-sm"
};
var _hoisted_11 = {
  "class": "font-semibold"
};

var _hoisted_12 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", {
  "class": "text-lm-dark dark:text-dm-light"
}, "ea.", -1
/* HOISTED */
);

var _hoisted_13 = {
  "class": "w-16 h-16 shrink-0"
};
var _hoisted_14 = ["src"];
var _hoisted_15 = {
  key: 0,
  "class": "flex gap-1"
};
var _hoisted_16 = {
  "class": "h-12 bg-lm-light dark:bg-dm-dark rounded-bl-xl w-1/2"
};

var _hoisted_17 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", null, "Remove item", -1
/* HOISTED */
);

var _hoisted_18 = [_hoisted_17];
var _hoisted_19 = {
  "class": "h-12 bg-lm-light dark:bg-dm-dark rounded-br-xl w-1/2"
};

var _hoisted_20 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", null, "Cancel", -1
/* HOISTED */
);

var _hoisted_21 = [_hoisted_20];
var _hoisted_22 = {
  key: 1,
  "class": "flex gap-1"
};
var _hoisted_23 = {
  "class": "h-12 bg-lm-light dark:bg-dm-dark rounded-bl-xl flex"
};

var _hoisted_24 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", {
  "class": "block w-3"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("svg", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("path", {
  d: "M1.29 13.57A1.25 1.25 0 0 1 0 12.3 1.25 1.25 0 0 1 1.29 11H22.7A1.25 1.25 0 0 1 24 12.29a1.25 1.25 0 0 1-1.29 1.28H1.3Z"
})])], -1
/* HOISTED */
);

var _hoisted_25 = [_hoisted_24];
var _hoisted_26 = {
  "class": "font-semibold flex h-12 items-center justify-center px-3"
};

var _hoisted_27 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", {
  "class": "block w-3"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("svg", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("g", {
  "clip-path": "url(#a)"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("path", {
  d: "M12 24a1.25 1.25 0 0 1-1.29-1.29V13.3H1.3A1.25 1.25 0 0 1 0 12a1.25 1.25 0 0 1 1.29-1.29h9.42V1.3A1.25 1.25 0 0 1 12 0a1.25 1.25 0 0 1 1.29 1.29v9.42h9.42A1.25 1.25 0 0 1 24 12a1.25 1.25 0 0 1-1.29 1.29H13.3v9.42A1.25 1.25 0 0 1 12 24Z"
})]), /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("defs", null, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("clipPath", {
  id: "a"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("path", {
  d: "M0 0h24v24H0z"
})])])])], -1
/* HOISTED */
);

var _hoisted_28 = [_hoisted_27];
var _hoisted_29 = {
  "class": "font-semibold flex-auto bg-lm-light dark:bg-dm-dark flex items-center justify-center"
};
var _hoisted_30 = {
  "class": "h-12 bg-lm-light dark:bg-dm-dark rounded-br-xl flex"
};

var _hoisted_31 = /*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", {
  "class": "block w-4"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("svg", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [/*#__PURE__*/(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("path", {
  d: "M4.37 24c-.54 0-1-.2-1.4-.6-.4-.4-.6-.87-.6-1.4V3H2a.97.97 0 0 1-1-1 .97.97 0 0 1 1-1h5.27a.97.97 0 0 1 1-1h6.8a.97.97 0 0 1 1 1h5.26a.97.97 0 0 1 1 1 .97.97 0 0 1-1 1h-.36v19c0 .53-.2 1-.6 1.4-.4.4-.87.6-1.4.6H4.37Zm0-21v19h14.6V3H4.37ZM7.9 18.13a.97.97 0 0 0 1 1 .97.97 0 0 0 1-1V6.83a.97.97 0 0 0-1-1 .97.97 0 0 0-1 1v11.3Zm5.53 0a.97.97 0 0 0 1 1 .97.97 0 0 0 1-1V6.83a.97.97 0 0 0-1-1 .97.97 0 0 0-1 1v11.3ZM4.37 3v19V3Z"
})])], -1
/* HOISTED */
);

var _hoisted_32 = [_hoisted_31];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,vue__WEBPACK_IMPORTED_MODULE_0__.openBlock)(), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementBlock)("div", _hoisted_1, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_2, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_3, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_4, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", null, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", _hoisted_5, (0,vue__WEBPACK_IMPORTED_MODULE_0__.toDisplayString)($props.item.product_title), 1
  /* TEXT */
  ), _hoisted_6, (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", _hoisted_7, "By " + (0,vue__WEBPACK_IMPORTED_MODULE_0__.toDisplayString)($props.item.vendor), 1
  /* TEXT */
  )]), !$props.item.product_has_only_default_variant ? ((0,vue__WEBPACK_IMPORTED_MODULE_0__.openBlock)(), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementBlock)("div", _hoisted_8, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", _hoisted_9, (0,vue__WEBPACK_IMPORTED_MODULE_0__.toDisplayString)($props.item.variant_title), 1
  /* TEXT */
  )])) : (0,vue__WEBPACK_IMPORTED_MODULE_0__.createCommentVNode)("v-if", true), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_10, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", _hoisted_11, "$" + (0,vue__WEBPACK_IMPORTED_MODULE_0__.toDisplayString)(Number($props.item.price / 100).toFixed(2)), 1
  /* TEXT */
  ), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createTextVNode)(), _hoisted_12])]), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_13, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("img", {
    src: $props.item.image,
    alt: "",
    "class": "max-h-full mx-auto"
  }, null, 8
  /* PROPS */
  , _hoisted_14)])])]), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createVNode)(vue__WEBPACK_IMPORTED_MODULE_0__.Transition, {
    name: "fade-200",
    mode: "out-in"
  }, {
    "default": (0,vue__WEBPACK_IMPORTED_MODULE_0__.withCtx)(function () {
      return [$data.removeItem ? ((0,vue__WEBPACK_IMPORTED_MODULE_0__.openBlock)(), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementBlock)("div", _hoisted_15, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_16, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("button", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.$store.dispatch('updateCartItem', {
            id: $props.item.id,
            qty: 0
          });
        }),
        "class": "font-semibold text-lm-negative dark:text-dm-negative w-full h-12 flex items-center justify-center transition",
        "aria-label": "Remove item from cart"
      }, _hoisted_18)]), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_19, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("button", {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $data.removeItem = false;
        }),
        "class": "font-semibold text-lm-darker hover:text-lm-darkest dark:text-dm-lighter dark:hover:text-dm-lightest w-full h-12 flex items-center justify-center transition",
        "aria-label": "Cancel and keep item in cart"
      }, _hoisted_21)])])) : ((0,vue__WEBPACK_IMPORTED_MODULE_0__.openBlock)(), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementBlock)("div", _hoisted_22, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_23, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("button", {
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.$store.dispatch('updateCartItem', {
            id: $props.item.id,
            qty: $props.item.quantity - 1
          });
        }),
        "class": "text-lm-darker hover:text-lm-darkest dark:text-dm-lighter dark:hover:text-dm-lightest w-12 h-12 flex items-center justify-center transition",
        "aria-label": "Decrease quantity"
      }, _hoisted_25), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("span", _hoisted_26, (0,vue__WEBPACK_IMPORTED_MODULE_0__.toDisplayString)($props.item.quantity), 1
      /* TEXT */
      ), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("button", {
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.$store.dispatch('updateCartItem', {
            id: $props.item.id,
            qty: $props.item.quantity + 1
          });
        }),
        "class": "text-lm-darker hover:text-lm-darkest dark:text-dm-lighter dark:hover:text-dm-lightest w-12 h-12 flex items-center justify-center transition",
        "aria-label": "Increase quantity"
      }, _hoisted_28)]), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_29, "$" + (0,vue__WEBPACK_IMPORTED_MODULE_0__.toDisplayString)(Number($props.item.final_line_price / 100).toFixed(2)), 1
      /* TEXT */
      ), (0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("div", _hoisted_30, [(0,vue__WEBPACK_IMPORTED_MODULE_0__.createElementVNode)("button", {
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return $data.removeItem = true;
        }),
        "class": "text-lm-darker hover:text-lm-darkest dark:text-dm-lighter dark:hover:text-dm-lightest w-12 h-12 flex items-center justify-center transition",
        "aria-label": "Remove item"
      }, _hoisted_32)])]))];
    }),
    _: 1
    /* STABLE */

  })]);
}

/***/ }),

/***/ "./src/components/Accordion.js":
/*!*************************************!*\
  !*** ./src/components/Accordion.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'Accordion',
  data: function data() {
    return {
      Accordion: {
        count: 0,
        active: null
      }
    };
  },
  provide: function provide() {
    return {
      Accordion: this.Accordion
    };
  },
  template:
  /*html*/
  "\n\t\t<slot></slot>\n  "
});

/***/ }),

/***/ "./src/components/AccordionItem.js":
/*!*****************************************!*\
  !*** ./src/components/AccordionItem.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  name: 'AccordionItem',
  inject: ["Accordion"],
  data: function data() {
    return {
      index: null
    };
  },
  computed: {
    visible: function visible() {
      return this.index == this.Accordion.active;
    }
  },
  methods: {
    open: function open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
    },
    start: function start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end: function end(el) {
      el.style.height = "";
    }
  },
  created: function created() {
    this.index = this.Accordion.count++;
  },
  template:
  /*html*/
  "\n\t\t<li class=\"accordion__item\">\n\t\t<div\n\t\t\tclass=\"accordion__trigger\"\n\t\t\t:class=\"{'accordion__trigger--active': visible}\"\n\t\t\t@click=\"open\">\n\n\t\t\t<!-- This slot will handle the title/header of the accordion and is the part you click on -->\n\t\t\t<slot name=\"accordion-trigger\"></slot>\n\t\t</div>\n\n\t\t<transition\n\t\t\tname=\"accordion\"\n\t\t\t@enter=\"start\"\n\t\t\t@after-enter=\"end\"\n\t\t\t@before-leave=\"start\"\n\t\t\t@after-leave=\"end\">\n\n\t\t\t<div class=\"accordion__content\"\n\t\t\t\t v-show=\"visible\">\n\t\t\t\t<!-- This slot will handle all the content that is passed to the accordion -->\n\t\t\t\t<slot name=\"accordion-content\"></slot>\n\t\t\t</div>\n\t\t</transition>\n\t\t</li>\n    "
});

/***/ }),

/***/ "./src/js/collection-app.js":
/*!**********************************!*\
  !*** ./src/js/collection-app.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "./node_modules/vue/dist/vue.esm-bundler.js");
/* harmony import */ var vue_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! vue-router */ "./node_modules/vue-router/dist/vue-router.mjs");
/* harmony import */ var _apollo_client_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @apollo/client/core */ "./node_modules/@apollo/client/link/http/createHttpLink.js");
/* harmony import */ var _apollo_client_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @apollo/client/core */ "./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js");
/* harmony import */ var _apollo_client_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @apollo/client/core */ "./node_modules/@apollo/client/core/ApolloClient.js");
/* harmony import */ var _vue_apollo_option__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @vue/apollo-option */ "./node_modules/@vue/apollo-option/dist/vue-apollo-option.esm.js");
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! graphql-tag */ "./node_modules/graphql-tag/lib/index.js");
/* harmony import */ var _routes_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../routes/routes */ "./src/routes/routes.js");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../store/store */ "./src/store/store.js");
/* harmony import */ var _components_Accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/Accordion */ "./src/components/Accordion.js");
/* harmony import */ var _components_AccordionItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../components/AccordionItem */ "./src/components/AccordionItem.js");
/* harmony import */ var _components_CartItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../components/CartItem */ "./src/components/CartItem.vue");
var _templateObject;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }











var router = (0,vue_router__WEBPACK_IMPORTED_MODULE_7__.createRouter)({
  history: (0,vue_router__WEBPACK_IMPORTED_MODULE_7__.createWebHistory)(),
  routes: _routes_routes__WEBPACK_IMPORTED_MODULE_2__["default"]
}); // HTTP connection to the API

var httpLink = (0,_apollo_client_core__WEBPACK_IMPORTED_MODULE_8__.createHttpLink)({
  uri: 'https://vipc.myshopify.com/api/2023-01/graphql.json',
  headers: {
    'X-Shopify-Storefront-Access-Token': '44f75ce1be3d91d23e28cf0bb911eb28',
    'Accept': 'application/graphql'
  }
}); // Cache implementation

var cache = new _apollo_client_core__WEBPACK_IMPORTED_MODULE_9__.InMemoryCache(); // Create the apollo client

var apolloClient = new _apollo_client_core__WEBPACK_IMPORTED_MODULE_10__.ApolloClient({
  link: httpLink,
  cache: cache
});
var apolloProvider = (0,_vue_apollo_option__WEBPACK_IMPORTED_MODULE_1__.createApolloProvider)({
  defaultClient: apolloClient
});
var app = (0,vue__WEBPACK_IMPORTED_MODULE_0__.createApp)({
  name: "Collection App",
  delimiters: ['${', '}'],
  components: {
    Accordion: _components_Accordion__WEBPACK_IMPORTED_MODULE_4__["default"],
    AccordionItem: _components_AccordionItem__WEBPACK_IMPORTED_MODULE_5__["default"],
    CartItem: _components_CartItem__WEBPACK_IMPORTED_MODULE_6__["default"]
  },
  data: function data() {
    return {
      collection: {},
      collectionCursor: null,
      refetchLoading: false,
      error: null
    };
  },
  computed: {
    collectionHandle: function collectionHandle() {
      return this.$route.params.collection;
    },
    filters: function filters() {
      if (this.collection.products) {
        var filters = this.collection.products.filters;
        var queryFilters = [];

        for (var i = 0; i < filters.length; i++) {
          if (filters[i].id in this.$route.query) {
            var filter = filters[i].id;
            var values = filters[i].values;

            if (Array.isArray(this.$route.query[filter])) {
              for (var _i = 0; _i < values.length; _i++) {
                if (this.$route.query[filter].includes(values[_i].label)) {
                  queryFilters.push(JSON.parse(values[_i].input));
                }
              }
            } else {
              for (var _i2 = 0; _i2 < values.length; _i2++) {
                if (values[_i2].label === this.$route.query[filter]) {
                  queryFilters.push(JSON.parse(values[_i2].input));
                }
              }
            }
          }
        }

        return queryFilters;
      }
    },
    sortKey: function sortKey() {
      if ('sort' in this.$route.query) {
        return this.$route.query['sort'];
      } else {
        return 'COLLECTION_DEFAULT';
      }
    },
    reverse: function reverse() {
      return 'reverse' in this.$route.query;
    },
    generalFilters: function generalFilters() {
      return this.collection.products.filters.filter(function (filter) {
        return filter.id.includes('.availability');
      });
    },
    identifierFilters: function identifierFilters() {
      return this.collection.products.filters.filter(function (filter) {
        return filter.id.includes('.product_type') || filter.id.includes('.vendor') || filter.id.includes('.identifiers');
      });
    },
    variantFilters: function variantFilters() {
      return this.collection.products.filters.filter(function (filter) {
        return filter.id.includes('.option');
      });
    },
    specFilters: function specFilters() {
      return this.collection.products.filters.filter(function (filter) {
        return filter.id.includes('.specs');
      });
    }
  },
  apollo: {
    collection: {
      query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_11__["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["query Collection($handle: String!, $cursor: String, $filters: [ProductFilter!], $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {\n                collection(handle: $handle) {\n                    id\n                    title\n                    products(first: 24, after: $cursor, filters: $filters, sortKey: $sortKey, reverse: $reverse) {\n                        edges {\n                            node {\n                                handle\n                                title\n                                vendor\n                                productType\n                                featuredImage {\n                                    height\n                                    url (transform: {\n                                        maxWidth: 400\n                                    })\n                                    width\n                                }\n                                priceRange {\n                                    maxVariantPrice {\n                                        amount\n                                    }\n                                    minVariantPrice {\n                                        amount\n                                    }\n                                }\n                                variants(first: 100) {\n                                    edges {\n                                        node {\n                                            id\n                                        }\n                                    }\n                                }\n                            }\n                            cursor\n                        },\n                        filters {\n                            id\n                            label\n                            type\n                            values {\n                                id\n                                label\n                                count\n                                input\n                            }\n                        },\n                        pageInfo {\n                            hasNextPage\n                        }\n                    }\n                }\n            }"]))),
      variables: function variables() {
        return {
          handle: this.collectionHandle,
          cursor: this.collectionCursor,
          filters: this.filters,
          sortKey: this.sortKey,
          reverse: this.reverse
        };
      },
      error: function error(_error) {
        this.error = _error;
        console.log(_error);
      },
      result: function result(_ref) {
        var data = _ref.data;
        this.refetchLoading = false;
        console.log(data);
      },
      deep: true,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    updateFilter: function updateFilter(filter, value) {
      var query = JSON.parse(JSON.stringify(this.$route.query));

      if (filter in this.$route.query) {
        if (Array.isArray(query[filter])) {
          var index = query[filter].indexOf(value);

          if (index > -1) {
            query[filter].splice(index, 1);
            this.$router.push({
              query: query
            });
          } else {
            query[filter].push(value);
            this.$router.push({
              query: query
            });
          }
        } else {
          if (query[filter] === value) {
            delete query[filter];
            this.$router.push({
              query: query
            });
          } else {
            query[filter] = [query[filter], value];
            this.$router.push({
              query: query
            });
          }
        }
      } else {
        query[filter] = value;
        this.$router.push({
          query: query
        });
      }
    },
    updateSort: function updateSort(sortBy, reverse) {
      var query = JSON.parse(JSON.stringify(this.$route.query));
      query['sort'] = sortBy;

      if (reverse === true) {
        query['reverse'] = reverse;
      } else {
        delete query['reverse'];
      }

      this.$router.push({
        query: query
      });
    },
    clearFilters: function clearFilters() {
      var query = JSON.parse(JSON.stringify(this.$route.query));

      for (var key in query) {
        if (key.includes('filter')) {
          delete query[key];
        }
      }

      this.$router.push({
        query: query
      });
    },
    loadMore: function loadMore() {
      var cursor = this.collection.products.edges[this.collection.products.edges.length - 1].cursor;
      this.refetchLoading = true;
      this.$apollo.queries.collection.fetchMore({
        variables: {
          cursor: cursor
        },
        updateQuery: function updateQuery(previousResult, _ref2) {
          var fetchMoreResult = _ref2.fetchMoreResult;
          var newProducts = fetchMoreResult.collection.products.edges; // const hasMore = fetchMoreResult.tagsPage.hasMore
          // this.showMoreEnabled = hasMore

          return {
            collection: {
              __typename: previousResult.collection.__typename,
              id: previousResult.collection.id,
              title: previousResult.collection.title,
              products: {
                __typename: previousResult.collection.products.__typename,
                edges: [].concat(_toConsumableArray(previousResult.collection.products.edges), _toConsumableArray(newProducts)),
                filters: previousResult.collection.products.filters,
                pageInfo: fetchMoreResult.collection.products.pageInfo
              } // hasMore,

            }
          };
        }
      });
    }
  },
  mounted: function mounted() {
    // console.log(this.$options.name + ' Loaded')
    this.$store.dispatch('refetchCart');
  }
});
app.use(_store_store__WEBPACK_IMPORTED_MODULE_3__["default"]);
app.use(router);
app.use(apolloProvider);
router.isReady().then(function () {
  if (document.getElementById('app')) {
    app.mount('#app');
  }
});

/***/ }),

/***/ "./src/routes/routes.js":
/*!******************************!*\
  !*** ./src/routes/routes.js ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var routes = [{
  path: '/',
  name: 'Index'
}, {
  path: '/collections/:collection',
  name: 'Collection'
}, {
  path: '/collections/:collection/products/:product',
  name: 'Collection Product'
}, {
  path: '/products/:product',
  name: 'Direct Product'
}, {
  path: '/pages/:page',
  name: 'Page'
}, {
  path: '/account',
  name: 'Account'
}, {
  path: '/account/login',
  name: 'Login'
}, {
  path: '/account/register',
  name: 'Register'
}, {
  path: '/search',
  name: 'Search'
}];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (routes);

/***/ }),

/***/ "./src/store/store.js":
/*!****************************!*\
  !*** ./src/store/store.js ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vuex */ "./node_modules/vuex/dist/vuex.esm-bundler.js");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var store = (0,vuex__WEBPACK_IMPORTED_MODULE_0__.createStore)({
  state: {
    layout: {
      filterDrawer: false,
      navDrawer: false,
      cartDrawer: false,
      sortDrawer: false
    },
    loading: {
      addToCart: '',
      updateCart: false
    },
    cart: {}
  },
  mutations: {
    setNavDrawerState: function setNavDrawerState(state, n) {
      state.layout.navDrawer = n;
    },
    setCartDrawerState: function setCartDrawerState(state, n) {
      state.layout.cartDrawer = n;
    },
    setFilterDrawerState: function setFilterDrawerState(state, n) {
      state.layout.filterDrawer = n;
    },
    setSortDrawerState: function setSortDrawerState(state, n) {
      state.layout.sortDrawer = n;
    },
    setCartState: function setCartState(state, cart) {
      state.cart = cart;
    },
    setAddToCartState: function setAddToCartState(state, n) {
      state.loading.addToCart = n;
    },
    setUpdateCartState: function setUpdateCartState(state, n) {
      state.loading.updateCart = n;
    }
  },
  actions: {
    toggleNavDrawer: function toggleNavDrawer(_ref) {
      var commit = _ref.commit,
          state = _ref.state;
      var n = !state.layout.navDrawer;
      commit('setNavDrawerState', n);
    },
    toggleCartDrawer: function toggleCartDrawer(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;
      var n = !state.layout.cartDrawer;
      commit('setCartDrawerState', n);
    },
    toggleFilterDrawer: function toggleFilterDrawer(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;
      var n = !state.layout.filterDrawer;
      commit('setFilterDrawerState', n);
    },
    toggleSortDrawer: function toggleSortDrawer(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;
      var n = !state.layout.sortDrawer;
      commit('setSortDrawerState', n);
    },
    dismissDrawers: function dismissDrawers(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state;

      if (state.layout.navDrawer) {
        commit('setNavDrawerState', false);
      }

      if (state.layout.cartDrawer) {
        commit('setCartDrawerState', false);
      }

      if (state.layout.filterDrawer) {
        commit('setFilterDrawerState', false);
      }

      if (state.layout.sortDrawer) {
        commit('setSortDrawerState', false);
      }
    },
    refetchCart: function refetchCart(_ref6) {
      var commit = _ref6.commit;
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET'
      }).then(function (data) {
        return data.json();
      }).then(function (data) {
        commit('setCartState', data);
        commit('setUpdateCartState', false);
        console.log(data);
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    },
    addToCart: function addToCart(_ref7, id) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;
      commit('setAddToCartState', 'loading');
      var variantId = id.replace('gid://shopify/ProductVariant/', '');
      var formData = {
        'items': [{
          id: variantId,
          quantity: 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        if (response.ok) {
          console.log(response);
          dispatch('refetchCart');
          commit('setAddToCartState', 'success');
          setTimeout(function () {
            commit('setAddToCartState', '');
          }, 1500);
        } else {
          commit('setAddToCartState', 'error');
          setTimeout(function () {
            commit('setAddToCartState', '');
          }, 1500);
        }
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    },
    updateCartItem: function updateCartItem(_ref8, cartItem) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;
      commit('setUpdateCartState', true);
      var formData = {
        'updates': _defineProperty({}, cartItem.id, cartItem.qty)
      };
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        if (response.ok) {
          dispatch('refetchCart');
        }
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    }
  },
  getters: {
    overlayActive: function overlayActive(state) {
      return state.layout.navDrawer || state.layout.cartDrawer || state.layout.filterDrawer || state.layout.sortDrawer;
    }
  }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (store);

/***/ }),

/***/ "./src/components/CartItem.vue":
/*!*************************************!*\
  !*** ./src/components/CartItem.vue ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _CartItem_vue_vue_type_template_id_6428cdfa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CartItem.vue?vue&type=template&id=6428cdfa */ "./src/components/CartItem.vue?vue&type=template&id=6428cdfa");
/* harmony import */ var _CartItem_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./CartItem.vue?vue&type=script&lang=js */ "./src/components/CartItem.vue?vue&type=script&lang=js");
/* harmony import */ var C_Users_kylne_Projects_vipc_node_modules_vue_loader_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./node_modules/vue-loader/dist/exportHelper.js */ "./node_modules/vue-loader/dist/exportHelper.js");




;
const __exports__ = /*#__PURE__*/(0,C_Users_kylne_Projects_vipc_node_modules_vue_loader_dist_exportHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"])(_CartItem_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_1__["default"], [['render',_CartItem_vue_vue_type_template_id_6428cdfa__WEBPACK_IMPORTED_MODULE_0__.render],['__file',"src/components/CartItem.vue"]])
/* hot reload */
if (false) {}


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (__exports__);

/***/ }),

/***/ "./src/components/CartItem.vue?vue&type=script&lang=js":
/*!*************************************************************!*\
  !*** ./src/components/CartItem.vue?vue&type=script&lang=js ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* reexport safe */ _node_modules_babel_loader_lib_index_js_clonedRuleSet_5_use_0_node_modules_vue_loader_dist_index_js_ruleSet_0_use_0_CartItem_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__["default"])
/* harmony export */ });
/* harmony import */ var _node_modules_babel_loader_lib_index_js_clonedRuleSet_5_use_0_node_modules_vue_loader_dist_index_js_ruleSet_0_use_0_CartItem_vue_vue_type_script_lang_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CartItem.vue?vue&type=script&lang=js */ "./node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CartItem.vue?vue&type=script&lang=js");
 

/***/ }),

/***/ "./src/components/CartItem.vue?vue&type=template&id=6428cdfa":
/*!*******************************************************************!*\
  !*** ./src/components/CartItem.vue?vue&type=template&id=6428cdfa ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "render": () => (/* reexport safe */ _node_modules_babel_loader_lib_index_js_clonedRuleSet_5_use_0_node_modules_vue_loader_dist_templateLoader_js_ruleSet_1_rules_2_node_modules_vue_loader_dist_index_js_ruleSet_0_use_0_CartItem_vue_vue_type_template_id_6428cdfa__WEBPACK_IMPORTED_MODULE_0__.render)
/* harmony export */ });
/* harmony import */ var _node_modules_babel_loader_lib_index_js_clonedRuleSet_5_use_0_node_modules_vue_loader_dist_templateLoader_js_ruleSet_1_rules_2_node_modules_vue_loader_dist_index_js_ruleSet_0_use_0_CartItem_vue_vue_type_template_id_6428cdfa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!../../node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CartItem.vue?vue&type=template&id=6428cdfa */ "./node_modules/babel-loader/lib/index.js??clonedRuleSet-5.use[0]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CartItem.vue?vue&type=template&id=6428cdfa");


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["/assets/vendor"], () => (__webpack_exec__("./src/js/collection-app.js")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);